var trTR = {
  locale: 'tr_TR',
  direction: 'ltr',
  date: {
    defaultFormat: {
      week: 'WW/YYYY',
      date: 'DD/MM/YYYY',
      month: 'MM/YYYY',
      year: 'YYYY',
      time: 'HH:mm:ss',
      dateTime: 'DD/MM/YYYY HH:mm:ss'
    },
    startDay: 0,
    shortMonthList: ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'],
    monthList: ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'],
    shortDayList: ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cts'],
    dayList: ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cts'],
    shortestDayList: ['Pa', 'Pz', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct']
  },
  'dynamic-date': {
    day: 'Gün',
    week: 'Hafta',
    month: 'Ay',
    quarter: 'Çeyrek',
    year: 'Yıl',
    before: '${value}${unit} önce'
  },
  'auto-complete.empty': 'Veri yok',
  'select.selected-count': 'Seçilen ${count} öğe',
  'date-time-picker.date': 'Tarih seçin',
  'image-view.zoom-out': 'Uzaklaştır',
  'input.placeholder': 'Lütfen girin',
  'empty.text': 'Veri yok',
  'date-picker.cancel': 'İptal',
  'date-picker.end': 'Bitiş saati',
  'cascader.empty': 'Veri yok',
  'upload.drop': 'Dosyaları buraya sürükleyin veya',
  'color.custom': 'Rengi özelleştirin',
  'cascader.titles': ['Seviye 1', 'Seviye 2', 'Seviye 3', 'Seviye 4', 'Seviye 5', 'Seviye 6', 'Seviye 7', 'Seviye 8'],
  'date-comparison.error-target': 'Karşılaştırma için bitiş saati seçin',
  'transfer.empty': 'Veri yok',
  'select.search.placeholder': 'Lütfen girin',
  'upload.click': 'Yüklemek için tıklayın',
  'date-time-picker.placeholder': 'Lütfen girin',
  'pager.jump': 'Yönlendir',
  'tree-select.placeholder': 'Lütfen girin',
  'dynamic-date.interval': 'Aralık',
  'modal.cancel': 'İptal',
  'image-view.rotate': 'Döndür',
  'tabs.more': 'Diğer',
  'popover.ok': 'Onayla',
  'transfer.placeholder': 'Lütfen girin',
  'date.month': 'Ay',
  'select.selected': 'Seçildi',
  'popover.cancel': 'İptal',
  'image-view.prev': 'Önceki',
  'table.emptyText': 'Veri yok',
  'date-time-picker.ok': 'Onayla',
  'table.filter.confirm': 'Onayla',
  'tree-select.empty': 'Veri yok',
  'dynamic-date.fixed-date': 'Sabit tarih',
  'date-comparison.compare': 'Karşılaştır',
  'auto-complete.placeholder': 'Lütfen girin',
  'time-picker.placeholder': 'Saat seçin',
  'date.month-first': true,
  'select.clear': 'Temizle',
  'date.year': '${year}',
  'date-comparison.yoy': 'Geçen yıl bu dönem',
  'image-view.zoom-to-origin': 'Orijinal',
  'schedule.title': 'Tarih/Saat',
  'schedule.clear': 'Temizle',
  'date-time-picker.end': 'Bitiş tarihi ve saati seçin',
  'dynamic-date.customize': 'Özelleştir',
  'date-picker.apply': 'Uygula',
  'schedule.selected': 'Seçilen saat',
  'dynamic-date.dynamic-date': 'Dinamik tarih',
  'select.placeholder': 'Lütfen seçin',
  'schedule.separator': ',',
  'cascader.search': 'Lütfen girin',
  'date-picker.invalid-range': 'Seçilen zaman aralığı seçilebilir aralığı aşıyor. Lütfen geçerli bir aralık girin.',
  'dynamic-date.date-preview': 'Tarih önizlemesi',
  'select.empty': 'Veri yok',
  'image-view.next': 'Sonraki',
  'date-time-picker.now': 'Şimdi',
  'date-time-picker.time': 'Saat seçin',
  'tree.empty': 'Veri yok',
  'pager.total': 'Toplam ${total} kayıt',
  'image-view.zoom-in': 'Yakınlaştır',
  'date-picker.placeholder': 'Tarih seçin',
  'textarea.placeholder': 'Lütfen girin',
  'date.week': 'Hafta',
  'pager.size': '${count} kayıt/sayfa',
  'modal.ok': 'Onayla',
  'date-picker.start': 'Başlangıç saati',
  'table.filter.reset': 'Sıfırla',
  'image-view.zoom-to-fit': 'Sığdır',
  'pager.page.placeholder': 'Lütfen girin',
  'select.select-all': 'Tümünü seç',
  'list-viewer.empty': 'Veri yok',
  'date-comparison.compare-text': 'VS',
  'transfer.source': 'Kaynak listesi',
  'date-time-picker.start': 'Başlangıç tarihi ve saati seçin',
  'date-comparison.error-source': 'Karşılaştırma için başlangıç saati seçin',
  'upload.error.overflow-count': 'Maksimum dosya sayısı aşıldı',
  'date-comparison.placeholder': 'Başlangıç saati - Bitiş saati',
  'time-range-picker.placeholder': 'Başlangıç saati - Bitiş saati',
  'date-comparison.mom': 'Önceki döneme kıyasla',
  'transfer.target': 'Hedef listesi'
};
export default trTR;